import { createGlobalStyle } from "styled-components"

import CursorActiveUrl from "../svg/cursor-active.svg"
import CursorUrl from "../svg/cursor.svg"

export const GlobalStyle = createGlobalStyle`
  body {
    cursor: url(${CursorUrl}) 90 12, auto;
  }

  a,
  input,
  textarea,
  label[for],
  select,
  button {
    cursor: url(${CursorActiveUrl}) 90 12, auto;
  }
`
